import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./Component/Commonmodel/Common.css"
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import { CommonProvider } from './context/CommonContext';
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter basename="/dccc"> */}
    <BrowserRouter basename="">
      <AuthProvider>
        <CommonProvider>
          <App />
        </CommonProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
